import type { ReactNode } from 'react';

type SplitScreenLayoutProps = {
  sidebar: ReactNode;
  main: ReactNode;
};

export function SplitScreenLayout({ sidebar, main }: SplitScreenLayoutProps) {
  return (
    <section className="demo-dock-page" aria-label="Demo Dock">
      <aside className="demo-dock-sidebar">{sidebar}</aside>
      <div className="demo-dock-main">{main}</div>
    </section>
  );
}
